module.exports = __webpack_public_path__ + "img/logo.b942a13d.png";